// 信用卡正則規則（已修正並覆蓋常見卡種）
const cards = {
  amex: /^3[47][0-9]{13}$/,
  dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
  jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
  mastercard: /^5[1-5][0-9]{2}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
  unionpay: /^(6[27][0-9]{14}|^(81[0-9]{14,17}))$/,
  visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/,
};

// Luhn 算法校驗
const luhnCheck = (cardNumber: string): boolean => {
  const digits = cardNumber.replace(/\D/g, '');
  let sum = 0;
  let shouldDouble = false;

  for (let i = digits.length - 1; i >= 0; i--) {
    let digit = parseInt(digits[i], 10);
    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
};

// 綜合校驗函數
export const VerifyCreditCard = (cardNumber: string): boolean => {
  // 1. 去除所有非數字字符
  const cleaned = cardNumber.replace(/\D/g, '');
  // 2. 基礎長度檢查（信用卡號通常為 13-19 位）
  if (cleaned.length < 13 || cleaned.length > 19) return false;

  // 3. 檢查是否符合任一信用卡正則
  const isCardTypeValid = Object.values(cards).some((regex) => regex.test(cleaned));

  // 4. Luhn 算法校驗
  return isCardTypeValid && luhnCheck(cleaned);
};
